import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONFIGURATION } from '@environments/app.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { UiHelper } from '@helpers/ui.helper';
import { ApiService } from '@services/api.service';

@Component({
  selector: 'left-links',
  templateUrl: '../sharedTemplates/left.links.component.html',
})
export class LeftLinksComponent implements OnInit {
  procesedData = [];

  constructor(public _Router: Router, private _UiHelper: UiHelper, private _ActivatedRoute: ActivatedRoute, private _ApiService: ApiService) {}

  onClickItem(e) {
    //this._UiHelper.setLoadingDialog(true);
    this._Router.navigate(['/' + e.NavigateURL], { queryParams: { MenuId: e.MobileHomeMenuId, TimeRangeId: e.TimeRangeId } });
    //this._Router.navigate(['/eventdetail', e]);
  }

  ngOnInit() {
    this._ApiService.getBottomMenu().then(x => {
      this.procesedData = x;
    });
  }

  openGameCasino() {
    const sessionid = '_' + Math.random().toString(36).substr(2, 9);
    this._ApiService.CasinoGameCreateToken(sessionid).then(result => {
      this.setCookie('gamesessionid', sessionid, 1, 'casino');
      window.open(result.url, '_blank');
    });
  }
  private setCookie(name: string, value: string, expireDays: number, path = '') {
    const d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 1 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    const cpath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }
}
